import React, { useEffect, useState } from "react";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getItemUoms } from "../../../../services/inventory/itemService";
function SearchItemUom({ itemID = 0, onSelectUom }) {
  const { reload } = useGlobalData();
  const [uoms, setUoms] = useState([]);
  useEffect(() => {
    getUomData(itemID);
  }, [itemID, reload]);
  return (
    <CustomDataTableSearch
      data={uoms}
      onRefreshData={() => {
        getUomData(itemID);
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectUom(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectUom(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Unit of Measurement Code",
          field: "uom",
          body: null,
          sortable: true,
        },
        {
          header: "Unit of Measurement Name",
          field: "uomName",
          body: null,
          sortable: true,
        },
      ]}
    />
  );

  async function getUomData(itemID) {
    const response = await getItemUoms(itemID);
    const { data } = response.data;
    setUoms(data.itemUoms);
  }
}

export default SearchItemUom;
